import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { categories } from '../styles/variables';

// ── Category hero cover photos ──
import jacquardImg   from '../images/jacquard.png.jpeg';
import dobbyImg      from '../images/dobbyweave.png.jpeg';
import plainImg      from '../images/plainweave.png.jpeg';
import terryImg      from '../images/terry.png.jpeg';
import dishclothImg  from '../images/dishcloth.png.jpeg';
import printedImg    from '../images/printed..png.jpeg';
import kitchensetImg from '../images/kitchenset.png.jpeg';
import othersImg     from '../images/others.png.jpeg';

// ── Jacquard product images ──
import jacquardClassicFloral    from '../images/jacquard/classic-floral-jacquard.jpg';
import jacquardGeometricDiamond from '../images/jacquard/geometric-diamond-weave.jpeg';
import jacquardHeritageStripe   from '../images/jacquard/heritage-stripe-jacquard.jpeg';
import jacquardBotanical        from '../images/jacquard/botanical-print-jacquard.jpeg';
import jacquardEdelweiss        from '../images/jacquard/edelweiss-jacquard.jpeg';
import jacquardGardenMotif      from '../images/jacquard/garden-motif-jacquard.jpeg';
import jacquardNautical         from '../images/jacquard/nautical-jacquard.jpeg';
import jacquardKitchenSet       from '../images/jacquard/jacquard-kitchen-set.jpeg';

// ── Dobby product images ──
import dobbyClassicCheck    from '../images/dobby/classic-check-dobby.jpeg';
import dobbyKitchenSet      from '../images/dobby/dobby-kitchen-set.jpeg';
import dobbyWaffleStripe    from '../images/dobby/waffle-stripe-dobby.jpeg';
import dobbySolidWaffle     from '../images/dobby/solid-waffle-dobby.jpeg';
import dobbyMultiStripe     from '../images/dobby/multi-stripe-dobby.jpeg';
import dobbyHerringbone     from '../images/dobby/herringbone-dobby.jpeg';
import dobbyBorderStripe    from '../images/dobby/border-stripe-dobby.jpeg';
import dobbyCheckeredSet    from '../images/dobby/checkered-dobby-set.jpeg';
import dobbyFineStripe      from '../images/dobby/fine-stripe-dobby.jpeg';
import dobbyGingham         from '../images/dobby/gingham-check-dobby.jpeg';
import dobbyFrenchStripe    from '../images/dobby/french-stripe-dobby.jpeg';

// ── Plain Weave product images ──
import plainColorfulStripe  from '../images/plain/colorful-stripe-plain.jpeg';
import plainClassicBorder   from '../images/plain/classic-border-stripe.jpeg';
import plainBuffaloCheck    from '../images/plain/buffalo-check-plain.jpeg';
import plainRedGrid         from '../images/plain/red-grid-plain.jpeg';
import plainYellowPlaid     from '../images/plain/yellow-plaid-plain.jpeg';
import plainBlueGingham     from '../images/plain/blue-gingham-plain.jpeg';
import plainMultiStripe     from '../images/plain/multi-stripe-plain.jpeg';
import plainRainbowCheck    from '../images/plain/rainbow-check-plain.jpeg';
import plainWindowpane      from '../images/plain/windowpane-check-plain.jpeg';
import plainKitchenSet      from '../images/plain/plain-weave-kitchen-set.jpeg';
import plainNavyMixedSet    from '../images/plain/navy-mixed-plain-set.jpeg';
import plainNaturalLinen    from '../images/plain/natural-linen-blend.jpeg';
import plainColouredStripe  from '../images/plain/coloured-stripe-plain.jpeg';
import plainStonewashed     from '../images/plain/stonewashed-plain.jpeg';

// ── Terry Kitchen product images ──
import terryBuffaloCheckSet    from '../images/terry/buffalo-check-terry-set.jpeg';
import terryMultiColorCheckSet from '../images/terry/multi-color-check-terry-set.jpeg';
import terryClassicCheck       from '../images/terry/classic-check-terry.jpeg';
import terryNeutralStripeSet   from '../images/terry/neutral-stripe-terry-set.jpeg';
import terryMultiStripe        from '../images/terry/multi-stripe-terry.jpeg';
import terryGreyStripeSet      from '../images/terry/grey-stripe-terry-set.jpeg';
import terryRainbowCheck       from '../images/terry/rainbow-check-terry.jpeg';
import terryWhiteBlueStripe    from '../images/terry/white-blue-stripe-terry.jpeg';
import terryGreyWovenStripe    from '../images/terry/grey-woven-stripe-terry.jpeg';
import terryWaffleCheckSet     from '../images/terry/waffle-check-terry-set.jpeg';

// ── Dish Cloth product images ──
import dishCheckSet        from '../images/dish/check-dish-cloth-set.jpeg';
import dishBeigeGrid       from '../images/dish/beige-grid-dish-cloth.jpeg';
import dishMulticolorCheck from '../images/dish/multicolor-check-dish-cloth.jpeg';
import dishMixedBulkSet    from '../images/dish/mixed-dish-cloth-bulk-set.jpeg';
import dishSolidGiftSet    from '../images/dish/solid-dish-cloth-gift-set.jpeg';

// ── Printed Kitchen product images ──
import printedApple          from '../images/printed/apple-print-printed.jpeg';
import printedBird           from '../images/printed/bird-print-printed.jpeg';
import printedCustomLogo     from '../images/printed/custom-logo-printed.jpeg';
import printedCustomText     from '../images/printed/custom-text-printed.jpeg';
import printedFloralBlock    from '../images/printed/floral-block-print.jpeg';
import printedFloralEmbroid  from '../images/printed/floral-embroidered-print.jpeg';
import printedFruitApplique  from '../images/printed/fruit-applique-printed.jpeg';
import printedGlassCloth     from '../images/printed/glass-cloth-printed.jpeg';
import printedKitchenNovelty from '../images/printed/kitchen-novelty-printed.jpeg';
import printedKitchenSet     from '../images/printed/printed-kitchen-set.jpeg';

// ── Kitchen Sets product images ──
import ksBlueCheckApron     from '../images/kitchensets/blue-check-apron-kitchen-set.jpeg';
import ksGreyStripeApron    from '../images/kitchensets/grey-stripe-apron-kitchen-set.jpeg';
import ksRedTartanApron     from '../images/kitchensets/red-tartan-apron-kitchen-set.jpeg';
import ksNavyUtensilSet     from '../images/kitchensets/navy-utensil-print-kitchen-set.jpeg';
import ksOrangeStarSet      from '../images/kitchensets/orange-star-kitchen-set.jpeg';
import ksButterflyOvenGlove from '../images/kitchensets/butterfly-print-double-oven-glove.jpeg';
import ksWhiteHalfApron     from '../images/kitchensets/white-half-apron.jpeg';
import ksWhiteBibApron      from '../images/kitchensets/white-bib-apron.jpeg';

// ── Others product images ──
import othersBabyDiaperBleached  from '../images/others/baby-diaper-bleached.jpeg';
import othersBabyDiaperGreige    from '../images/others/baby-diaper-greige.jpeg';
import othersBabyDiaperPrinted   from '../images/others/baby-diaper-printed.jpeg';
import othersBarMop              from '../images/others/bar-mop.jpeg';
import othersBarMopDyed          from '../images/others/bar-mop-dyed.jpeg';
import othersBathrobe            from '../images/others/bathrobe.png';
import othersCheesecloth         from '../images/others/cheesecloth.jpeg';
import othersFlameRetardant      from '../images/others/flame-retardant-fabric.png';
import othersFutaBeachTowel      from '../images/others/futa-beach-towel.jpeg';
import othersHandTowel           from '../images/others/hand-towel.jpg';
import othersShopTowels          from '../images/others/shop-towels.jpeg';
import othersTableCoverPlainDyed from '../images/others/table-cover-plain-dyed.jpeg';
import othersTableCoverPrinted   from '../images/others/table-cover-printed.jpeg';
import othersTableCoverYarnDyed  from '../images/others/table-cover-yarn-dyed.jpeg';

// ── Cover image map ──
const coverImageMap = {
  'jacquard-weave':  jacquardImg,
  'dobby-weave':     dobbyImg,
  'plain-weave':     plainImg,
  'terry-kitchen':   terryImg,
  'dish-cloth':      dishclothImg,
  'printed-kitchen': printedImg,
  'kitchen-sets':    kitchensetImg,
  'others':          othersImg,
};

// ── Per-category product image maps ──
// Keys MUST exactly match product names (lowercased) from variables.js and CategoryPage extra cards
const jacquardProductImages = {
  // from variables.js products
  'classic floral jacquard':    jacquardClassicFloral,
  'geometric diamond jacquard': jacquardGeometricDiamond,
  'heritage stripe jacquard':   jacquardHeritageStripe,
  'botanical leaf jacquard':    jacquardBotanical,
  'royal border jacquard':      jacquardEdelweiss,
  'wave pattern jacquard':      jacquardNautical,
  'garden motif jacquard':      jacquardGardenMotif,
  'jacquard kitchen set':       jacquardKitchenSet,
  // from CategoryPage jacquardExtraCards
  'garden vegetable jacquard':  jacquardGardenMotif,
  'jacquard mixed kitchen set': jacquardKitchenSet,
};

const dobbyProductImages = {
  // from variables.js products
  'classic dobby check':              dobbyClassicCheck,
  'herringbone dobby':                dobbyHerringbone,
  'waffle dobby':                     dobbySolidWaffle,
  'stripe dobby':                     dobbyMultiStripe,
  'border stripe dobby':              dobbyBorderStripe,
  'checkered dobby':                  dobbyCheckeredSet,
  'dobby kitchen set':                dobbyKitchenSet,
  'gingham check dobby':              dobbyGingham,
  // from CategoryPage dobbyExtraCards
  'yarn dyed waffle dobby':           dobbyMultiStripe,
  'fine stripe dobby':                dobbyFineStripe,
  'mini chess dobby kitchen towel':   dobbyFrenchStripe,
  'chess board dobby':                dobbyCheckeredSet,
  'mono check dobby':                 dobbyGingham,
  'waffle stripe dobby':              dobbyWaffleStripe,
  'checkered dobby set':              dobbyCheckeredSet,
  'kitchen set dobby':                dobbyKitchenSet,
  'gingham dobby':                    dobbyGingham,
  'french stripe dobby':              dobbyFrenchStripe,
};

const plainProductImages = {
  // from variables.js products
  'natural linen blend': plainNaturalLinen,
  'coloured stripe':     plainColouredStripe,
  'stone washed':        plainStonewashed,
  'colorful stripe':     plainColorfulStripe,
  'yellow plaid':        plainYellowPlaid,
  'blue gingham':        plainBlueGingham,
  'multi stripe':        plainMultiStripe,
  'rainbow check':       plainRainbowCheck,
  'classic check':       plainWindowpane,
  'multi check':         plainKitchenSet,
  'navy mixed set':      plainNavyMixedSet,

  // optional aliases / backward compatibility
  'stonewashed plain':   plainStonewashed,
  'plain weave set':     plainKitchenSet,
};

const terryProductImages = {
  // from variables.js products
  'buffalo check terry':              terryBuffaloCheckSet,
  'multi colour check terry':         terryMultiColorCheckSet,
  'classic check terry':              terryClassicCheck,
  'neutral stripe terry':             terryNeutralStripeSet,
  'striped terry':                    terryMultiStripe,
  'grey stripe terry':                terryGreyStripeSet,
  'coloured check terry':             terryRainbowCheck,
  'white blue stripe terry':          terryWhiteBlueStripe,
  'grey woven stripe terry':          terryGreyWovenStripe,
  'waffle check terry':               terryWaffleCheckSet,
  'classic terry bar mop':            terryClassicCheck,
  'velour terry towel':               terryBuffaloCheckSet,
  'striped terry towel':              terryMultiStripe,
  'embroidered terry':                terryClassicCheck,
  // from CategoryPage terryExtraCards
  'jacquard terry towel':             terryBuffaloCheckSet,
  'multi colour check terry set':     terryMultiColorCheckSet,
  'multi color check terry':          terryMultiColorCheckSet,
  'neutral stripe terry set':         terryNeutralStripeSet,
  'multi stripe terry':               terryMultiStripe,
  'grey stripe terry set':            terryGreyStripeSet,
  'rainbow check terry':              terryRainbowCheck,
  'grey woven stripe reversed terry': terryGreyWovenStripe,
  'waffle check terry set':           terryWaffleCheckSet,
  'buffalo check terry set':          terryBuffaloCheckSet,
  'terry kitchen set':                terryWaffleCheckSet,
  'blue stripe terry':                terryWhiteBlueStripe,
  'woven stripe terry':               terryGreyWovenStripe,
};

const dishProductImages = {
  // from variables.js products
  'check dish cloth':            dishCheckSet,
  'waffle dish cloth':           dishBeigeGrid,
  'muslin dish cloth':           dishMulticolorCheck,
  'flour sack cloth':            dishMixedBulkSet,
  'classic check dish cloth':    dishCheckSet,
  // from CategoryPage dishExtraCards
  'beige grid dish cloth':       dishBeigeGrid,
  'multicolor check dish cloth': dishMulticolorCheck,
  'mixed dish cloth bulk set':   dishMixedBulkSet,
  'solid dish cloth gift set':   dishSolidGiftSet,
  // extra aliases
  'dish cloth set':              dishCheckSet,
  'windowpane dish cloth':       dishBeigeGrid,
  'neutral dish cloth':          dishBeigeGrid,
  'coloured check dish cloth':   dishMulticolorCheck,
  'bulk dish cloth set':         dishMixedBulkSet,
  'mixed dish cloth set':        dishMixedBulkSet,
  'solid dish cloth':            dishSolidGiftSet,
  'gift dish cloth set':         dishSolidGiftSet,
};

const printedProductImages = {
  // from variables.js products
  'botanical print':              printedFloralBlock,
  'seasonal christmas print':     printedKitchenNovelty,
  'custom logo print':            printedCustomLogo,
  'farmhouse pattern':            printedFloralEmbroid,
  'novelty print':                printedKitchenNovelty,
  'fruit print':                  printedFruitApplique,
  'bird print':                   printedBird,
  'apple print':                  printedApple,
  // from CategoryPage extra cards (exact names)
  'apple print kitchen towel':    printedApple,
  'bird print kitchen towel':     printedBird,
  'floral block print':           printedFloralBlock,
  'floral embroidered print':     printedFloralEmbroid,
  'fruit appliqué printed':       printedFruitApplique,
  'glass cloth printed':          printedGlassCloth,
  'kitchen novelty printed':      printedKitchenNovelty,
  'custom logo printed':          printedCustomLogo,
  'custom text printed':          printedCustomText,
  'printed kitchen set':          printedKitchenSet,
  // extra aliases
  'apple print printed':          printedApple,
  'bird print printed':           printedBird,
  'custom logo kitchen towel':    printedCustomLogo,
  'custom text kitchen towel':    printedCustomText,
  'floral block printed':         printedFloralBlock,
  'floral embroidered printed':   printedFloralEmbroid,
  'fruit applique printed':       printedFruitApplique,
  'fruit applique kitchen towel': printedFruitApplique,
  'glass cloth kitchen towel':    printedGlassCloth,
  'novelty print kitchen towel':  printedKitchenNovelty,
  'printed kitchen towel set':    printedKitchenSet,
};

const kitchenSetsProductImages = {
  // from variables.js products
  '3-piece kitchen set':               ksBlueCheckApron,
  '5-piece kitchen set':               ksOrangeStarSet,
  'gift box collection':               ksNavyUtensilSet,
  'seasonal gift set':                 ksRedTartanApron,
  // from CategoryPage kitchenSetsExtraCards (exact names)
  'blue check apron kitchen set':      ksBlueCheckApron,
  'grey stripe apron kitchen set':     ksGreyStripeApron,
  'red tartan apron kitchen set':      ksRedTartanApron,
  'navy utensil print kitchen set':    ksNavyUtensilSet,
  'orange star kitchen set':           ksOrangeStarSet,
  'butterfly print double oven glove': ksButterflyOvenGlove,
  'white half apron':                  ksWhiteHalfApron,
  'white bib apron':                   ksWhiteBibApron,
  // extra aliases
  'blue check apron set':              ksBlueCheckApron,
  'grey stripe apron set':             ksGreyStripeApron,
  'red tartan apron set':              ksRedTartanApron,
  'navy utensil set':                  ksNavyUtensilSet,
  'star print kitchen set':            ksOrangeStarSet,
  'butterfly oven glove':              ksButterflyOvenGlove,
  'waist apron':                       ksWhiteHalfApron,
  'plain white apron':                 ksWhiteBibApron,
};

const othersProductImages = {
  // ── directly imported images (exact variables.js names) ──
  'baby diaper bleached':       othersBabyDiaperBleached,
  'baby diaper greige':         othersBabyDiaperGreige,
  'baby diaper printed':        othersBabyDiaperPrinted,
  'bar mop':                    othersBarMop,
  'bar mop dyed':               othersBarMopDyed,
  'bathrobe':                   othersBathrobe,
  'cheesecloth':                othersCheesecloth,
  // FIXED: Changed to match exact variables.js name
  'fr hvac duct wrapping fabric': othersFlameRetardant,
  'futa beach towel':           othersFutaBeachTowel,
  'hand towel':                 othersHandTowel,
  'shop towels':                othersShopTowels,
  'table cover plain dyed':     othersTableCoverPlainDyed,
  'table cover printed':        othersTableCoverPrinted,
  'table cover yarn dyed':      othersTableCoverYarnDyed,
  // ── variables.js products that have no dedicated image ──
  // mapped to the closest visually appropriate available image
  'oven gloves / mitts':        othersBarMop,
  'oven gloves':                othersBarMop,
  'oven mitts':                 othersBarMopDyed,
  'aprons':                     othersBathrobe,
  'pot holders':                othersBarMopDyed,
  'table runners':              othersTableCoverYarnDyed,
  'tea towels':                 othersHandTowel,
  'kitchen towels':             othersHandTowel,
  'glass cloth':                othersShopTowels,
  'napkins':                    othersTableCoverPlainDyed,
  'place mats':                 othersTableCoverPrinted,
  'beach towel':                othersFutaBeachTowel,
  'bath towel':                 othersBathrobe,
  'face cloth':                 othersHandTowel,
  'cleaning cloths':            othersShopTowels,
  'microfibre cloth':           othersShopTowels,
  'flannel':                    othersCheesecloth,
  'muslin':                     othersCheesecloth,
  'gauze':                      othersCheesecloth,
};

// ── Extra cards per category (must mirror CategoryPage exactly) ──
const jacquardExtraCards = [
  { name: 'Garden Vegetable Jacquard',  desc: 'Colorful vegetable and garden motifs woven in vibrant jacquard.' },
  { name: 'Jacquard Mixed Kitchen Set', desc: 'Coordinated jacquard kitchen set with mixed patterns and weaves.' },
];

const dobbyExtraCards = [
  { name: 'Yarn Dyed Waffle Dobby',          desc: 'Vibrant multicolor stripes on crisp white dobby base.' },
  { name: 'Fine Stripe Dobby',               desc: 'Delicate fine stripes for a subtle, elegant kitchen look.' },
  { name: 'Mini Chess Dobby Kitchen Towel',  desc: 'Classic French-style blue and white mini chess pattern.' },
  { name: 'Border Stripe Dobby',             desc: 'Bold border stripes with a premium herringbone body.' },
  { name: 'Chess Board Dobby',               desc: 'Colorful checkered dobby towels, perfect as a gift set.' },
  { name: 'Mono Check Dobby',                desc: 'Traditional mono check in a range of fresh colors.' },
  { name: 'Waffle Stripe Dobby',             desc: 'Waffle weave with refined dobby stripe detailing.' },
  { name: 'Dobby Kitchen Set',               desc: 'Coordinated dobby kitchen set with mixed patterns.' },
];

const plainExtraCards = [
  { name: 'Colorful Stripe Flat',   desc: 'Vibrant hanging stripes in orange and green on flat weave.' },
  { name: 'Yellow Plaid Flat',      desc: 'Cheerful mustard yellow plaid, ideal for gifting.' },
  { name: 'Blue Gingham Flat',      desc: 'Classic royal blue gingham on smooth flat weave cotton.' },
  { name: 'Multi Stripe Flat',      desc: 'White flat weave with multicolor centre stripe detailing.' },
  { name: 'Rainbow Check Flat',     desc: 'Bold multicolor check in a vibrant rainbow palette.' },
  { name: 'Classic Check',          desc: 'Elegant thin-line windowpane check in blue, yellow and red.' },
  { name: 'Multi Check Flat',       desc: 'Rolled and folded flat weave kitchen set, export-ready.' },
  { name: 'Navy Mixed Flat Set',    desc: 'Five-piece navy mixed flat weave set with check, gingham & solid.' },
];

const terryExtraCards = [
  { name: 'Jacquard Terry Towel',             desc: 'Classic black & white buffalo check terry towels stacked in a set.' },
  { name: 'Multi Colour Check Terry Set',     desc: 'Coordinated check terry set in brown, red and blue colourways.' },
  { name: 'Classic Check Terry',              desc: 'Traditional red, green and blue check terry kitchen towels.' },
  { name: 'Neutral Stripe Terry Set',         desc: 'Mixed neutral stripe and waffle terry set in beige and brown tones.' },
  { name: 'Multi Stripe Terry',               desc: 'Vivid multicolour stripes on mustard, teal, orange and black terry base.' },
  { name: 'Grey Stripe Terry Set',            desc: 'Crisp 4-piece grey and white stripe terry kitchen towel set.' },
  { name: 'Rainbow Check Terry',              desc: 'Bold rainbow-coloured check pattern on a deep charcoal terry base.' },
  { name: 'White Blue Stripe Terry',          desc: 'Classic white terry with clean navy blue centre stripes.' },
  { name: 'Grey Woven Stripe Reversed Terry', desc: 'Premium grey woven stripe terry with plush loop reverse.' },
  { name: 'Waffle Check Terry Set',           desc: 'White waffle-weave terry set with teal, red and black check options.' },
];

const dishExtraCards = [
  { name: 'Beige Grid Dish Cloth',       desc: 'Elegant beige and gold windowpane grid dish cloth, soft and absorbent.' },
  { name: 'Multicolor Check Dish Cloth', desc: 'Bold red, blue and orange check dish cloths stacked in assorted colours.' },
  { name: 'Mixed Dish Cloth Bulk Set',   desc: 'Large bulk set of mixed check and stripe dish cloths in vibrant colours.' },
  { name: 'Solid Dish Cloth Gift Set',   desc: 'Premium navy, green and grey solid dish cloths presented as a gift set.' },
];

const printedExtraCards = [
  { name: 'Apple Print Kitchen Towel',  desc: 'Cheerful apple motif screen-printed on soft cotton kitchen towels.' },
  { name: 'Bird Print Kitchen Towel',   desc: 'Decorative bird and branch print in a crisp, nature-inspired palette.' },
  { name: 'Floral Block Print',         desc: 'Hand-inspired floral block print in bold, export-quality ink.' },
  { name: 'Floral Embroidered Print',   desc: 'Delicate floral embroidery detailing on a fine woven cotton base.' },
  { name: 'Fruit Appliqué Printed',     desc: 'Vibrant fruit appliqué and print combination for a lively kitchen accent.' },
  { name: 'Glass Cloth Printed',        desc: 'Traditional glass cloth weave with a bold printed stripe or motif.' },
  { name: 'Kitchen Novelty Printed',    desc: 'Fun novelty kitchen-themed prints, popular for gifting and retail display.' },
  { name: 'Custom Logo Printed',        desc: 'Premium blank canvas for custom brand logo printing — MOQ available.' },
  { name: 'Custom Text Printed',        desc: 'Personalised text printing on quality kitchen towels for branded orders.' },
  { name: 'Printed Kitchen Set',        desc: 'Coordinated printed kitchen towel set, styled and export-ready.' },
];

const kitchenSetsExtraCards = [
  { name: 'Blue Check Apron Kitchen Set',      desc: 'Navy blue check apron with matching oven mitts and pot holders — a complete coordinated set.' },
  { name: 'Grey Stripe Apron Kitchen Set',     desc: 'Classic grey and white ticking stripe apron, oven mitt and potholder in a neat gift set.' },
  { name: 'Red Tartan Apron Kitchen Set',      desc: 'Bold red tartan plaid apron, oven glove and pot holder — ideal for festive gifting.' },
  { name: 'Navy Utensil Print Kitchen Set',    desc: 'Navy apron paired with utensil-motif oven mitt and potholder, styled for export retail.' },
  { name: 'Orange Star Kitchen Set',           desc: 'Vibrant orange and green star-print full kitchen set: apron, double glove, mitt, towels & potholder.' },
  { name: 'Butterfly Print Double Oven Glove', desc: 'Elegant sage green butterfly-print double oven glove with terry lining — premium export quality.' },
  { name: 'White Half Apron',                  desc: 'Clean white waist apron with a large front pocket — versatile for hospitality and catering.' },
  { name: 'White Bib Apron',                   desc: 'Classic full-length white bib apron, soft cotton, ideal for branded or plain export orders.' },
];

const othersExtraCards = [
  { name: 'Baby Diaper Bleached',      desc: 'Soft bleached white baby diaper fabric — absorbent and gentle for infant care.' },
  { name: 'Baby Diaper Greige',        desc: 'Natural greige baby diaper cloth — unbleached, chemical-free and export-ready.' },
  { name: 'Baby Diaper Printed',       desc: 'Cheerful printed baby diaper fabric with playful motifs for retail packaging.' },
  { name: 'Bar Mop',                   desc: 'Classic white bar mop towels — heavy-duty, highly absorbent and ideal for commercial use.' },
  { name: 'Bar Mop Dyed',              desc: 'Colour-striped bar mop towels — dyed for easy identification in busy kitchen environments.' },
  { name: 'Bathrobe',                  desc: 'Plush terry bathrobe in neutral tones — premium quality for hotel and spa export orders.' },
  { name: 'Cheesecloth',               desc: 'Fine open-weave cheesecloth — food-grade cotton for straining, wrapping and crafting.' },
  // FIXED: Changed to match exact variables.js name and description
  { name: 'FR HVAC Duct Wrapping Fabric', desc: 'Fire Retardant grey fabric used for HVAC duct insulation wrapping and industrial fire protection applications.' },
  { name: 'Futa Beach Towel',          desc: 'Lightweight futa-style beach towel — quick-dry, compact and ideal for holiday retail.' },
  { name: 'Hand Towel',                desc: 'Soft cotton hand towels with classic border detailing — suitable for hotel and home export.' },
  { name: 'Shop Towels',               desc: 'Industrial-grade shop towels — lint-free, durable and ideal for automotive and workshop use.' },
  { name: 'Table Cover Plain Dyed',    desc: 'Smooth plain-dyed table covers in versatile colourways for hospitality and catering.' },
  { name: 'Table Cover Printed',       desc: 'Decorative printed table covers — vibrant patterns for retail, gifting and event use.' },
  { name: 'Table Cover Yarn Dyed',     desc: 'Premium yarn-dyed table covers with classic woven patterns for restaurant and hotel export.' },
];

// Map of extra cards per category id
const categoryExtraCards = {
  'jacquard-weave':  jacquardExtraCards,
  'dobby-weave':     dobbyExtraCards,
  'plain-weave':     plainExtraCards,
  'terry-kitchen':   terryExtraCards,
  'dish-cloth':      dishExtraCards,
  'printed-kitchen': printedExtraCards,
  'kitchen-sets':    kitchenSetsExtraCards,
  'others':          othersExtraCards,
};

// Returns the full product list a category page actually shows
// (variables.js products + extra cards, deduplicated by name)
const getFullProductList = (cat) => {
  const base = cat.products || [];
  const extras = categoryExtraCards[cat.id] || [];
  const names = new Set(base.map(p => p.name));
  const uniqueExtras = extras.filter(p => !names.has(p.name));
  return [...base, ...uniqueExtras];
};

// ── Lookup image for any product in any category ──
const getProductImage = (categoryId, productName) => {
  const key = productName.toLowerCase().trim();
  if (categoryId === 'jacquard-weave')  return jacquardProductImages[key]      || null;
  if (categoryId === 'dobby-weave')     return dobbyProductImages[key]          || null;
  if (categoryId === 'plain-weave')     return plainProductImages[key]          || null;
  if (categoryId === 'terry-kitchen')   return terryProductImages[key]          || null;
  if (categoryId === 'dish-cloth')      return dishProductImages[key]           || null;
  if (categoryId === 'printed-kitchen') return printedProductImages[key]        || null;
  if (categoryId === 'kitchen-sets')    return kitchenSetsProductImages[key]    || null;
  if (categoryId === 'others')          return othersProductImages[key]         || null;
  return null;
};

const ProductDetailPage = () => {
  const { categoryId, productSlug } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // Product data passed via router state
  const { product, productImg: stateImg } = location.state || {};

  const cat = categories.find((c) => c.id === categoryId);

  // Always resolve image — use state if present, otherwise look it up by name
  const productImg = stateImg || (product ? getProductImage(categoryId, product.name) : null);

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  if (!cat || !product) {
    return (
      <div style={{
        paddingTop: '120px',
        textAlign: 'center',
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'var(--font-body)',
      }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔍</div>
        <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '2rem', marginBottom: '0.75rem', color: 'var(--color-dark)' }}>
          Product Not Found
        </h2>
        <p style={{ color: 'var(--color-dark-grey)', marginBottom: '1.5rem', fontSize: '1rem' }}>
          This product may have moved or been updated.
        </p>
        <button className="btn-primary" onClick={() => navigate('/')}>Go Home</button>
      </div>
    );
  }

  const handleInquire = () => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('contact');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 400);
  };

  const categoryName = cat.shortName || cat.name;

  return (
    <div className="product-detail-page" style={{ minHeight: '100vh', background: 'var(--color-warm-white)' }}>

      {/* ── Hero Section ── */}
      <div style={{
        position: 'relative',
        width: '100%',
        minHeight: '260px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'flex-end',
      }}>
        <img
          src={coverImageMap[cat.id]}
          alt={cat.name}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            filter: 'brightness(0.55)',
          }}
        />
        <div style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to bottom, rgba(10,8,5,0.15) 0%, rgba(10,8,5,0.75) 100%)',
        }} />

        {/* Breadcrumb + Title */}
        <div style={{
          position: 'relative',
          zIndex: 2,
          width: '100%',
          padding: 'clamp(1rem, 3vw, 2rem)',
          paddingTop: '90px',
        }}>
          {/* Breadcrumb */}
          <nav style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '0.35rem',
            marginBottom: '1.25rem',
          }}>
            <button
              onClick={() => navigate('/')}
              style={breadcrumbBtnStyle}
              onMouseEnter={e => e.currentTarget.style.color = '#D4AF7A'}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
            >Home</button>
            <span style={breadcrumbSepStyle}>/</span>
            <button
              onClick={() => navigate(`/category/${cat.id}`)}
              style={breadcrumbBtnStyle}
              onMouseEnter={e => e.currentTarget.style.color = '#D4AF7A'}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
            >{categoryName}</button>
            <span style={breadcrumbSepStyle}>/</span>
            <span style={{ fontFamily: "'Jost', sans-serif", fontSize: '0.78rem', color: '#D4AF7A', letterSpacing: '0.06em' }}>
              {product.name}
            </span>
          </nav>

          <h1 style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: 'clamp(1.8rem, 4vw, 3rem)',
            fontWeight: 400,
            color: '#fff',
            lineHeight: 1.15,
            letterSpacing: '-0.01em',
            maxWidth: '700px',
          }}>
            {product.name}
          </h1>
          <div style={{ width: '48px', height: '2px', background: 'linear-gradient(90deg, #B8965A, transparent)', marginTop: '0.85rem' }} />
        </div>
      </div>

      {/* ── Main Content ── */}
      <div className="container" style={{ padding: 'clamp(2rem, 5vw, 4rem) clamp(1rem, 3vw, 2rem)' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 'clamp(1.5rem, 4vw, 3.5rem)',
          alignItems: 'start',
        }}>

          {/* ── Product Image ── */}
          <div style={{ position: 'relative' }}>
            <div style={{
              position: 'relative',
              borderRadius: '4px',
              overflow: 'hidden',
              boxShadow: '0 12px 48px rgba(0,0,0,0.14)',
              background: productImg ? 'transparent' : `linear-gradient(135deg, ${cat.bgColor}, ${cat.color}22)`,
              aspectRatio: '4/3',
            }}>
              {productImg ? (
                <img
                  src={productImg}
                  alt={product.name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block',
                  }}
                />
              ) : (
                <div style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '5rem',
                }}>
                  {cat.emoji}
                </div>
              )}

              {/* Gold corner accent */}
              <div style={{
                position: 'absolute',
                bottom: 0,
                right: 0,
                width: '60px',
                height: '60px',
                background: `linear-gradient(135deg, transparent 50%, ${cat.color}55 50%)`,
                pointerEvents: 'none',
              }} />
            </div>

            {/* Category badge */}
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.4rem',
              marginTop: '1.1rem',
              padding: '0.4rem 1rem',
              background: cat.bgColor || '#F5F0E8',
              border: `1px solid ${cat.color}44`,
              borderRadius: 'var(--radius-full)',
              fontFamily: 'var(--font-body)',
              fontSize: '0.8rem',
              fontWeight: 500,
              color: cat.color,
              letterSpacing: '0.04em',
            }}>
              <span>{cat.emoji}</span>
              <span>{categoryName}</span>
            </div>
          </div>

          {/* ── Product Info ── */}
          <div style={{ paddingTop: '0.5rem' }}>
            {/* Name */}
            <h2 style={{
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontSize: 'clamp(1.6rem, 3vw, 2.4rem)',
              fontWeight: 500,
              color: 'var(--color-dark)',
              lineHeight: 1.2,
              marginBottom: '0.5rem',
            }}>
              {product.name}
            </h2>

            {/* Gold rule */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              marginBottom: '1.25rem',
            }}>
              <div style={{ width: '36px', height: '1.5px', background: 'var(--color-gold, #B8965A)' }} />
              <div style={{ width: '6px', height: '6px', background: 'var(--color-gold, #B8965A)', transform: 'rotate(45deg)' }} />
              <div style={{ width: '36px', height: '1.5px', background: 'var(--color-gold, #B8965A)' }} />
            </div>

            {/* Description */}
            {product.desc && (
              <p style={{
                fontFamily: 'var(--font-body)',
                fontSize: 'clamp(0.9rem, 1.3vw, 1.05rem)',
                fontWeight: 300,
                color: 'var(--color-dark-grey)',
                lineHeight: 1.8,
                marginBottom: '1.75rem',
                letterSpacing: '0.02em',
              }}>
                {product.desc}
              </p>
            )}

            {/* Spec Tags */}
            {(product.material || product.gsm || product.size) && (
              <div style={{ marginBottom: '1.75rem' }}>
                <div style={{
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.72rem',
                  fontWeight: 600,
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                  color: 'var(--color-dark-grey)',
                  marginBottom: '0.6rem',
                }}>
                  Specifications
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                  {product.material && (
                    <SpecBadge icon="⚗" label="Material" value={product.material} color={cat.color} />
                  )}
                  {product.gsm && (
                    <SpecBadge icon="⚖" label="Weight" value={product.gsm} color={cat.color} />
                  )}
                  {product.size && (
                    <SpecBadge icon="📐" label="Size" value={product.size} color={cat.color} />
                  )}
                </div>
              </div>
            )}

            {/* Category Specs */}
            {cat.specs && Object.keys(cat.specs).length > 0 && (
              <div style={{
                background: 'var(--color-beige, #F5F0E8)',
                border: '1px solid var(--color-border, #E8E0D0)',
                borderRadius: '4px',
                padding: '1.1rem 1.25rem',
                marginBottom: '1.75rem',
              }}>
                <div style={{
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.72rem',
                  fontWeight: 600,
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                  color: 'var(--color-dark-grey)',
                  marginBottom: '0.8rem',
                }}>
                  Category Details
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  {Object.entries(cat.specs).map(([key, value]) => (
                    <div key={key} style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      gap: '1rem',
                      fontFamily: 'var(--font-body)',
                      fontSize: '0.85rem',
                      borderBottom: '1px solid var(--color-border, #E8E0D0)',
                      paddingBottom: '0.4rem',
                    }}>
                      <span style={{ color: 'var(--color-dark-grey)', fontWeight: 400, flexShrink: 0 }}>{key}</span>
                      <span style={{ color: 'var(--color-dark)', fontWeight: 500, textAlign: 'right' }}>{value}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* CTA Buttons */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
              <button
                className="btn-primary"
                onClick={handleInquire}
                style={{ flex: '1 1 160px', minWidth: '140px' }}
              >
                ✉ Inquire Now
              </button>
              <button
                onClick={() => navigate(`/category/${cat.id}`)}
                style={{
                  flex: '1 1 160px',
                  minWidth: '140px',
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.82rem',
                  fontWeight: 500,
                  letterSpacing: '0.06em',
                  color: 'var(--color-dark)',
                  background: 'transparent',
                  border: '1px solid var(--color-border, #E8E0D0)',
                  borderRadius: '2px',
                  padding: '0.75rem 1.5rem',
                  cursor: 'pointer',
                  transition: 'var(--trans-base)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.4rem',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = cat.color; e.currentTarget.style.color = cat.color; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--color-border, #E8E0D0)'; e.currentTarget.style.color = 'var(--color-dark)'; }}
              >
                ← View All {categoryName}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ── Other Products in Category ── */}
      <RelatedProducts currentProduct={product} cat={cat} navigate={navigate} />

      {/* ── Other Categories ── */}
      <OtherCategories currentCatId={cat.id} navigate={navigate} />

    </div>
  );
};

// ── Spec Badge Component ──
const SpecBadge = ({ icon, label, value, color }) => (
  <div style={{
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.35rem',
    padding: '0.35rem 0.85rem',
    background: '#fff',
    border: `1px solid ${color}33`,
    borderRadius: 'var(--radius-full)',
    fontFamily: 'var(--font-body)',
    fontSize: '0.8rem',
    color: 'var(--color-dark)',
  }}>
    <span>{icon}</span>
    <span style={{ color: 'var(--color-dark-grey)', fontSize: '0.75rem' }}>{label}:</span>
    <span style={{ fontWeight: 500 }}>{value}</span>
  </div>
);

// ── Related Products Component ──
const RelatedProducts = ({ currentProduct, cat, navigate }) => {
  const related = getFullProductList(cat)
    .filter(p => p.name !== currentProduct.name)
    .slice(0, 4);

  if (!related.length) return null;

  return (
    <div style={{
      background: 'var(--color-beige, #F5F0E8)',
      borderTop: '1px solid var(--color-border, #E8E0D0)',
      padding: 'clamp(2rem, 5vw, 3.5rem) 0',
    }}>
      <div className="container" style={{ padding: '0 clamp(1rem, 3vw, 2rem)' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div className="section-eyebrow">More From This Collection</div>
          <h3 style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: 'clamp(1.4rem, 3vw, 2rem)',
            fontWeight: 400,
            color: 'var(--color-dark)',
          }}>
            Related {cat.shortName} Products
          </h3>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
          gap: '1.25rem',
        }}>
          {related.map((p) => (
            <RelatedCard
              key={p.name}
              product={p}
              cat={cat}
              navigate={navigate}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

// ── Related Card ──
const RelatedCard = ({ product, cat, navigate }) => {
  const [hovered, setHovered] = React.useState(false);

  // Resolve the image for this related product
  const resolvedImg = getProductImage(cat.id, product.name);

  const handleClick = () => {
    const slug = product.name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    navigate(`/product/${cat.id}/${slug}`, {
      state: { product, productImg: resolvedImg, categoryId: cat.id },
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: '#fff',
        border: `1px solid ${hovered ? cat.color + '66' : 'var(--color-border, #E8E0D0)'}`,
        borderRadius: '4px',
        overflow: 'hidden',
        cursor: 'pointer',
        transition: 'all 0.25s ease',
        transform: hovered ? 'translateY(-3px)' : 'translateY(0)',
        boxShadow: hovered ? '0 8px 24px rgba(0,0,0,0.09)' : 'none',
      }}
    >
      {/* Thumbnail — real image if available, gradient fallback otherwise */}
      <div style={{
        height: '140px',
        position: 'relative',
        overflow: 'hidden',
        background: resolvedImg
          ? 'transparent'
          : `linear-gradient(135deg, ${cat.bgColor || '#f5f0e8'}, ${cat.color}22)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        {resolvedImg ? (
          <img
            src={resolvedImg}
            alt={product.name}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block',
              transform: hovered ? 'scale(1.05)' : 'scale(1)',
              transition: 'transform 0.35s ease',
            }}
          />
        ) : (
          <span style={{ fontSize: '2.5rem' }}>{cat.emoji}</span>
        )}
      </div>

      <div style={{ padding: '0.75rem 0.9rem' }}>
        <div style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontSize: '0.95rem',
          fontWeight: 500,
          color: 'var(--color-dark)',
          lineHeight: 1.3,
          marginBottom: '0.3rem',
        }}>
          {product.name}
        </div>
        {product.desc && (
          <p style={{
            fontFamily: 'var(--font-body)',
            fontSize: '0.75rem',
            color: 'var(--color-dark-grey)',
            lineHeight: 1.5,
            margin: 0,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}>
            {product.desc}
          </p>
        )}
      </div>
    </div>
  );
};

// ── Other Categories Component ──
const OtherCategories = ({ currentCatId, navigate }) => {
  const others = categories.filter((c) => c.id !== currentCatId);

  return (
    <div style={{
      background: 'var(--color-warm-white, #FDFAF5)',
      borderTop: '1px solid var(--color-border, #E8E0D0)',
      padding: 'clamp(1.75rem, 4vw, 3rem) 0',
    }}>
      <div className="container" style={{ padding: '0 clamp(1rem, 3vw, 2rem)' }}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <div className="section-eyebrow">Explore More</div>
          <h3 style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: 'clamp(1.2rem, 2.5vw, 1.6rem)',
            fontWeight: 400,
            color: 'var(--color-dark)',
          }}>
            Other Categories
          </h3>
        </div>

        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '0.6rem',
          justifyContent: 'center',
        }}>
          {others.map((other) => (
            <OtherCategoryPill key={other.id} category={other} navigate={navigate} />
          ))}
        </div>
      </div>
    </div>
  );
};

// ── Other Category Pill ──
const OtherCategoryPill = ({ category, navigate }) => {
  const [hovered, setHovered] = React.useState(false);

  return (
    <button
      onClick={() => navigate(`/category/${category.id}`)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'var(--font-body)',
        fontSize: '0.82rem',
        fontWeight: 500,
        color: hovered ? category.color : 'var(--color-dark-grey)',
        background: 'var(--color-warm-white, #FDFAF5)',
        border: `1px solid ${hovered ? category.color : 'var(--color-border, #E8E0D0)'}`,
        borderRadius: 'var(--radius-full, 999px)',
        padding: '0.5rem 1.25rem',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        transform: hovered ? 'translateY(-2px)' : 'translateY(0)',
        boxShadow: hovered ? `0 4px 12px ${category.color}22` : 'none',
      }}
    >
      {category.shortName}
    </button>
  );
};

// ── Breadcrumb button style ──
const breadcrumbBtnStyle = {
  fontFamily: "'Jost', sans-serif",
  fontSize: '0.78rem',
  fontWeight: 500,
  letterSpacing: '0.06em',
  color: 'rgba(255,255,255,0.7)',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  transition: 'color 0.2s',
};

const breadcrumbSepStyle = {
  color: 'rgba(255,255,255,0.3)',
  fontSize: '0.75rem',
};

export default ProductDetailPage;